import { UserPIN } from '@flowwai-frontend/shared-web/iam/data-access'
import { getErrorMessageFromErrorType } from '@flowwai-frontend/shared/utils/common'

import { GetUserPinStatusQuery as Query } from './query.generatedTypes'

interface Args {
   data: Query
   onSuccess?: (userPIN: UserPIN) => void
   onFailure?: (errorMessage: string, data: Query['getUserPinStatus']) => void
}

const useResponseHandler = () => {
   const handleAPIResponse = (args: Args): void => {
      const { data, onSuccess, onFailure } = args

      const responseData = data.getUserPinStatus
      switch (responseData.__typename) {
         case 'UserPinStatus':
         case 'UserPinExpired':
         case 'UserPinLocked': {
            const userPIN: UserPIN = {
               isPINConfigured: !!responseData.lastChangedAt,
               generatedOn: new Date(responseData.lastChangedAt ?? ''),
               expiresOn: new Date(responseData.expiresAt ?? '')
            }

            onSuccess?.(userPIN)
            break
         }
         default: {
            const errorMessage = getErrorMessageFromErrorType(
               responseData.__typename
            )
            onFailure?.(errorMessage, responseData)
         }
      }
   }

   return {
      handleAPIResponse
   }
}

export default useResponseHandler
